import { render, staticRenderFns } from "./ActivityNotificationsTable.vue?vue&type=template&id=4b02be54&scoped=true&"
import script from "./ActivityNotificationsTable.vue?vue&type=script&lang=js&"
export * from "./ActivityNotificationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b02be54",
  null
  
)

export default component.exports